export default {
      id: "icon-lock-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-lock",
      toString: function () {
        return this.url;
      }
    }